import type { IncidenceChangeItem } from 'modules/payroll_bundle/lib/types'
import AdditionalCompensationHistoryItem from 'modules/payroll_bundle/pages/IncidenceDetailPage/_AdditionalCompensationHistoryItem'

interface ChangeItemProps {
  change: IncidenceChangeItem
}

const ChangeItem = ({ change }: ChangeItemProps) => {
  const currentValue = change.currentValue
  const previousValue = change.previousValue

  return (
    <AdditionalCompensationHistoryItem
      change={change}
      currentValue={currentValue}
      previousValue={previousValue}
    />
  )
}

export default ChangeItem
